import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Home from "@/pages/Home";
import Works from "@/pages/Works";
import About from "@/pages/About";
import Project from "@/pages/Project";
import CursorTrail from "@/components/CursorTrail";
import ClickSound from "@/components/ClickSound";
import PortfolioNav from "@/components/PortfolioNav";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/works" element={<Works />} />
        <Route path="/project/:slug" element={<Project />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </AnimatePresence>
  );
}

function AppContent() {
  return (
    <>
      <ClickSound />
      <CursorTrail />
      {/* Fixed transparent navigation bar */}
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          pointerEvents: "none",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <PortfolioNav />
      </div>
      <AnimatedRoutes />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
